'use client';

import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { TrackingFunction } from '../types';

export const useLandingPageEmailTracking = (props = {}, autoTrack: boolean = false): TrackingFunction => {
  return useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.LANDING_PAGE_EMAIL_FILLED,
      properties: props,
    },
    autoTrack,
  );
};
